export default __webpack_public_path__ + "static/dashkit-alt-dark-e5edd45f75ed1b333ad056c95026f8c7.jpg";